import { RtError } from '@recruitee/utils';

/**
 * Exception thrown when attempting to attach a null portal to a host.
 * @docs-private
 */
export class NullPortalError extends RtError {
  constructor() {
    super('NullPortalError', 'Must provide a portal to attach');
  }
}

/**
 * Exception thrown when attempting to attach a portal to a host that is already attached.
 * @docs-private
 */
export class PortalAlreadyAttachedError extends RtError {
  constructor() {
    super('PortalAlreadyAttachedError', 'Host already has a portal attached');
  }
}

/**
 * Exception thrown when attempting to attach a portal to an already-disposed host.
 * @docs-private
 */
export class PortalHostAlreadyDisposedError extends RtError {
  constructor() {
    super('PortalHostAlreadyDisposedError', 'This PortalHost has already been disposed');
  }
}

/**
 * Exception thrown when attempting to attach an unknown portal type.
 * @docs-private
 */
export class UnknownPortalTypeError extends RtError {
  constructor() {
    super(
      'UnknownPortalTypeError',
      'Attempting to attach an unknown Portal type. ' +
        'BasePortalHost accepts either a ComponentPortal or a TemplatePortal.',
    );
  }
}

/**
 * Exception thrown when attempting to attach a portal to a null host.
 * @docs-private
 */
export class NullPortalHostError extends RtError {
  constructor() {
    super('NullPortalHostError', 'Attempting to attach a portal to a null PortalHost');
  }
}

/**
 * Exception thrown when attempting to detach a portal that is not attached.
 * @docs-private
 */
export class NoPortalHostAttachedError extends RtError {
  constructor() {
    super(
      'NoPortalHostAttachedError',
      'Attempting to detach a portal that is not attached to a host',
    );
  }
}
